export const holidays = {
  "repeating": [
    {
      "name": "New Year's Day",
      "date": "--01-01"
    },
    {
      "name": "Independence Day",
      "date": "--07-04"
    },
    {
      "name": "Christmas Day",
      "date": "--12-25"
    }
  ],
  "explicit": [
    {
      "name": "Memorial Day",
      "date": "2026-05-25"
    },
    {
      "name": "Labor Day",
      "date": "2026-09-07"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2026-11-26"
    },
    {
      "name": "Memorial Day",
      "date": "2027-05-31"
    },
    {
      "name": "Labor Day",
      "date": "2027-09-06"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2027-11-25"
    },
    {
      "name": "Memorial Day",
      "date": "2028-05-29"
    },
    {
      "name": "Labor Day",
      "date": "2028-09-04"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2028-11-23"
    },
    {
      "name": "Memorial Day",
      "date": "2029-05-28"
    },
    {
      "name": "Labor Day",
      "date": "2029-09-03"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2029-11-22"
    },
    {
      "name": "Memorial Day",
      "date": "2030-05-27"
    },
    {
      "name": "Labor Day",
      "date": "2030-09-02"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2030-11-28"
    },
    {
      "name": "Memorial Day",
      "date": "2031-05-26"
    },
    {
      "name": "Labor Day",
      "date": "2031-09-01"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2031-11-27"
    },
    {
      "name": "Memorial Day",
      "date": "2032-05-31"
    },
    {
      "name": "Labor Day",
      "date": "2032-09-06"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2032-11-25"
    },
    {
      "name": "Memorial Day",
      "date": "2033-05-30"
    },
    {
      "name": "Labor Day",
      "date": "2033-09-05"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2033-11-24"
    },
    {
      "name": "Memorial Day",
      "date": "2034-05-29"
    },
    {
      "name": "Labor Day",
      "date": "2034-09-04"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2034-11-23"
    },
    {
      "name": "Memorial Day",
      "date": "2035-05-28"
    },
    {
      "name": "Labor Day",
      "date": "2035-09-03"
    },
    {
      "name": "Thanksgiving Day",
      "date": "2035-11-22"
    }
  ]
}